@if (row) {
  <mat-checkbox
    (change)="onSelectChange($event)"
    [checked]="selectionService.isSelected(row) || disabledRow || selectionService.hasReachedSelectionLimit(row)"
    [indeterminate]="selectionService.hasReachedSelectionLimit(row)"
    [disabled]="disabledRow || selectionService.hasReachedSelectionLimit(row)"
  />
} @else {
  <mat-checkbox
    (change)="onSelectChange($event)"
    [checked]="(selectionService.hasSelection$ | async) && (selectionService.allSelected$ | async)"
    [indeterminate]="(selectionService.hasSelection$ | async) && (selectionService.allSelected$ | async) === false"
  />
}
